import qs from "qs";
import axios from "axios";
// import {IHttpGet} from '../type'
class Http {
  get(op) {
    const { url, options, params } = op;
    return axios
      .get(url, {
        ...options,
        params: {
          ...params,
          t: new Date().getTime()
        },
        withCredentials: true
      })
      .then(({ data }) => {
        return data;
      })
      .catch(err => {
        return { err };
      });
  }

  getNotWithCredentials(op) {
    const { url, options, params } = op;
    return axios
      .get(url, {
        ...options,
        params: {
          ...params
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch(err => {
        return { err };
      });
  }

  post(url, params, options) {
    return axios
      .post(
        url,
        {
          data: params
        },
        {
          ...options,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          transformRequest: [
            function({ data }) {
              return qs.stringify(data);
            }
          ]
        }
      )
      .then(({ data }) => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  }

  postTest(option) {
    const { url } = option;
    return axios
      .post(url, {}, { withCredentials: true })
      .then(({ data }) => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  }

  postJson(option) {
    const { url, params, options } = option;
    return axios
      .post(url, {
        ...params
      })
      .then(({ data }) => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  }

  postData(url, params, options) {
    return axios
      .post(url, [...params])
      .then(({ data }) => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  }

  put(op) {
    const { url, params, options } = op;
    return axios
      .put(url, params, {
        withCredentials: true,
        ...options
      })
      .then(({ data }) => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  }

  putData(url, params, da) {
    return axios
      .put(url, {
        ...da
      })
      .then(({ data }) => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  }

  getTimeOut(url, options) {
    return axios
      .get(url, {
        ...options
      })
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  HEADTimeOut(url, options) {
    return axios
      .head(url, {
        ...options
      })
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  }
}

export default new Http();



// WEBPACK FOOTER //
// ./src/publics/Http/index.js